"use client";

function useWhatsappContext() {
  const getContext = (extraObject?: WhatsappCustomValues) => {
    return Object.keys(extraObject || {}).reduce((acc, key) => {
      const value = extraObject?.[key as keyof WhatsappCustomValues];

      acc[key] = value;

      return acc;
    }, {} as WhatsappCustomValues);
  };

  return { getContext };
}

export default useWhatsappContext;
